import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';
import { residualValueGridFragment } from './fragments';

export const RESIDUAL_VALUE_GRID_SAVED = gql`
  subscription residualValueGridSaved {
    residualValueGridSaved {
      residualValueGrid {
        ...residualValueGrid
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
  ${residualValueGridFragment}
`;

export const RESIDUAL_VALUE_GRID_DELETED = gql`
  subscription residualValueGridDeleted {
    residualValueGridDeleted {
      id
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const RESIDUAL_VALUE_GRID_STATE_UPDATED = gql`
  subscription residualValueGridStateUpdated($id: Int!) {
    residualValueGridStateUpdated(id: $id) {
      residualValueGrid {
        ...residualValueGrid
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
  ${residualValueGridFragment}
`;

export const RESIDUAL_VALUE_GRID_ITEMS_DETAILS_SAVED = gql`
  subscription residualValueGridItemsDetailsSaved($id: Int!) {
    residualValueGridItemsDetailsSaved(id: $id) {
      gridId
      itemData {
        gridId
        items {
          itemId
          itemName
        }
      }
      detailsData {
        gridId
        itemId
        details {
          id
          itemId
          mileageFrom
          mileageTo
          period
          rvPercent
        }
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const RESIDUAL_VALUE_GRID_DUPLICATED = gql`
  subscription residualValueGridDuplicated {
    residualValueGridDuplicated {
      id
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
